import { ListAlt } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FilterBar, TableData } from 'components';
import { getAlertMonitorService, getAllAlertsService } from 'services/admin/alertsService';
import { errorAlert } from 'helpers/alerts';
import { setCurrentMonitor, setMonitor } from 'redux/slices/admin/alertSlice';
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';
import Images from 'assets/images';
import Image from 'components/common/Image';

const AlertMonitorScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [types, setTypes] = useState(null)
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  console.log(location);
  
  useEffect(() => {
    getAllAlertsService().then((result) => {
      setTypes(result)
    }).catch(error => errorAlert(error))
    // eslint-disable-next-line
  }, []);

  const handlerTxns = (item) => {
    // Las alertas de conciliación no tienen transacciones propias: llevan a la pantalla de
    // conciliaciones filtrada por instancia y día conciliado, igual que el botón del correo.
    // La tarea corre de madrugada sobre el día anterior al del evento. Los eventos viejos no
    // guardaban la instancia; con ellos sólo se filtra por día.
    if (item.alert?.code === 'concilliationAlert') {
      const params = new URLSearchParams({ fecha: moment(item.createdAt).subtract(1, 'days').format('YYYY-MM-DD') });
      const cred = item.providerCredential?.id || item.providerCredential;
      if (cred) params.set('cred', String(cred));
      navigate(`/admin/proveedores/conciliaciones?${params}`);
      return;
    }
    dispatch(setCurrentMonitor(item));
    navigate('transacciones');
  }

  const handlerSubmit = (data) => {
    setLoading(true);
    data.page = page;
    data.limit = rowsPerPage;
    getAlertMonitorService(data).then((response) => {
      setList(response.data);
      setTotal(response.total);
    }).catch(error => errorAlert(error))
      .finally(() => setLoading(false));
  }
  return (
    <>
      <FilterBar
        handlerFilter={handlerSubmit}
        page={page}
        limit={rowsPerPage}
        showTitle={false}
        defaultValues={{
          id: location.state?.id || '',
        }}
        filters={[
          {
            name: "type",
            label: "Tipo",
            type: "select",
            multiple: true,
            data:[ 
              {
                id: 'Intermitencia',
                name: 'Intermitencia'
              },
              ...(types || [])
            ],
            loading: types == null,
            render: (value) => value.map((id) => {
              if(id === 'Intermitencia') return id;
              const type = types.find(o => o.id === id);
              return type?.name;
            }).join(', ')
          },
          {
            name: 'id',
            label: "Identificador",
            type: "text",
          },
        ]}
      />
      <TableData
        dataRows={list}
        total={total}
        loading={loading}
        // headerButtons={[]}
        dataTitle={[
          "Id",
          "Tipo",
          "Mensaje",
          "Instancia",
          "Fecha y hora",
          "Visto",
        ]}
        onChangePage={page => setPage(page)}
        onChangeRowsPerPage={rowsPerPage => setRowsPerPage(rowsPerPage)}
        formatter={({ identification, alert, message, providerCredential, createdAt, viewed }) => [
          identification,
          message.includes('intermitencia') ? 'Intermitencia' : alert?.name,
          message ? { type: 'text', value: message, maxWidth: 200 } : '-',
          providerCredential?.name_connector || '-',
          moment(createdAt).format("DD/MM/YYYY HH:mm:ss"),
          viewed ? moment(viewed).format("DD/MM/YYYY HH:mm:ss") : '-',
        ]}
        actions={[
          {
            label: "Transacciones",
            icon: <Image src={Images.icon.actions} alt="transactions" />,
            onClick: (data) => handlerTxns(data)
          },
        ]}
      />
    </>

  )
}

export default AlertMonitorScreen